/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authServiceAccountsListApiKeys } from "../../funcs/authServiceAccountsListApiKeys.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListServiceAccountApiKeysRequest$inboundSchema,
};

export const tool$authServiceAccountsListApiKeys: ToolDefinition<typeof args> =
  {
    name: "auth-service-accounts-list-api-keys",
    description: `List a service account's API keys`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await authServiceAccountsListApiKeys(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
